<template>
  <div class="footer-view">
    <div class="footer-view-content">
        <div class="logo">
            <img class="logo-icon" :src="logo_pic" alt="">
        </div>
        <div class="container">
            <div class="left-box">
                <div class="u-flex u-col-center">
                    <img class="tel-pic" :src="tel_pic" alt="">
                    <span class="bold font-24 u-m-l-10">{{ data.phone }}</span>
                </div>
                <p  v-if="data.security">{{ '闽公安备案：' }}{{data.security}}</p>
                <p v-if="data.telecom">{{ '增值电信业务经营许可证：' }}{{data.telecom}}</p>
                <p class="cursor"  @click="set_url(data.security_url)" v-if="data.icp_number">{{ 'ICP备案号：' }}{{data.icp_number}}</p>
            </div>
            <div class="equity">
                <div class="bold font-20">{{ '用户权益' }}</div>
                <p @click="agreement(0)">{{ '用户协议' }}</p>
                <p @click="agreement(9)">{{ '服务条款' }}</p>
                <p @click="agreement(1)">{{ '隐私政策' }}</p>
				
				
			
            </div>
            <div class="right-box">
                <div class="bold font-20 u-m-b-38">{{ '更多媒体' }}</div>
                <div>
                    <img class="mediun-logo cursor" :class="{'u-m-l-50': index}" v-for="(pic, index) in mediumList" :key="index" :src="pic.img" alt="">
                </div>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
export default {
	name: 'FooterView',
	data() {
		return {
			logo_pic: require('@/assets/footer/logo.png'),
			tel_pic: require('@/assets/footer/teleph-icon.png'),
			tel_num: '400-000-0000',
			mediumList: [
				{
					name: '微博',
					img: require('@/assets/footer/weibo-icon.png'),
				},
				{
					name: '企业微信',
					img: require('@/assets/footer/qiwei-icon.png'),
				},
				{
					name: 'sph',
					img: require('@/assets/footer/douy-icon.png'),
				},
				{
					name: '微博',
					img: require('@/assets/footer/sph-icon.png'),
				},
			],
			data:[]
		}
	}, 
	mounted() {
		this.fetchWebsiteConfig();
	},
	methods: {
		async fetchWebsiteConfig() {
			const response = await fetch(this.$apiBaseUrl+"/api/website/website_conf");
			const data = await response.json();
			this.data=data.data
			console.log(data.data)
		},
		agreement(type){
			window.open(this.$apiBaseUrl+'/pc/page/agreement.html?type='+type+'&isInApp=2')
		},
		set_url(url){
			if(url){
				window.open(url)
			}
		}
	}
	
}
</script>
<style scoped lang="scss">
.footer-view {
    width: 100%;
    height: 369px;
    background-color: #1A1F24;
    color: #fff;
	.cursor{
		cursor:pointer
	}
    &-content {
        width: 1200px;
        margin: 0 auto;
        .logo {
            padding-bottom: 19px;
            border-bottom: 1px solid #565A5E;
            .logo-icon {
                height: 42px;
                margin-top: 28px;
            }
        }
        .container {
            display: flex;
            justify-content: space-between;
            margin-top: 24px;
            .left-box {
                .tel-pic {
                    width: 24px;
                    height: 24px;
                }
            }
            .right-box {
               .mediun-logo {
                    width: 56px;
               }
            }
			.equity{
				p {
					cursor: pointer;
				}

			}
            p {
                color: #CDCDCD;
				
            }
        }
    }
}
</style>
